var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "graduationDel" }, [
    _c(
      "div",
      { staticClass: "menu" },
      [
        _c("h4", [_vm._v("提交历史")]),
        _c(
          "el-collapse",
          { attrs: { accordion: "" } },
          _vm._l(_vm.data, function (item, index) {
            return _c(
              "el-collapse-item",
              { key: index, attrs: { title: item.title } },
              _vm._l(item.paperStudent, function (itemToo, indexToo) {
                return _c("div", { key: itemToo.id, staticClass: "item" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item-title_text",
                        on: {
                          click: function ($event) {
                            return _vm.handleNodeClick(itemToo)
                          },
                        },
                      },
                      [
                        _c("div", [
                          _vm._v("历史" + _vm._s(indexToo + 1) + " - "),
                        ]),
                        _c(
                          "div",
                          { class: { active: itemToo.is_adopt == 2 } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm._f("status")(itemToo.is_adopt))
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  itemToo.is_adopt == 2
                    ? _c("div", { staticClass: "item-p" }, [
                        _c("span", [_vm._v("驳回原因：")]),
                        _c("div", {
                          domProps: { innerHTML: _vm._s(itemToo.content) },
                        }),
                      ])
                    : _vm._e(),
                ])
              }),
              0
            )
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("i", {
          staticClass: "el-icon-arrow-left",
          attrs: { size: "20" },
          on: {
            click: function ($event) {
              return _vm.$base.goReturn()
            },
          },
        }),
        _c("h4", [_vm._v("论文展示区")]),
        _vm.wordSrc == ""
          ? [_c("div", { staticClass: "box-span" }, [_vm._v("请选择论文")])]
          : [
              _vm.loading
                ? _c("div", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "box-loading",
                  })
                : _c("div", { staticClass: "box-content" }, [
                    _c("div", {
                      attrs: { id: "wordView" },
                      domProps: { innerHTML: _vm._s(_vm.wordSrc) },
                    }),
                  ]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }